export default {"src":"/_next/static/media/Illustration-launch.5b133082.svg","height":402,"width":456,"blurWidth":0,"blurHeight":0};